import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M9.558 3.958c-.92 0-1.667.747-1.667 1.667v3.87a3.542 3.542 0 1 0 3.75 0v-3.87c0-.92-.746-1.667-1.666-1.667h-.417Zm5.417 0h-.417m.417 2.5h-.417m.417 2.5h-.417m-4.792 3.75v-1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);